import React from "react"
import { Card, CardBody } from "reactstrap"
import PropTypes from "prop-types"

const LocationOtherDetailsCard = ({ location }) => {
    if (!location) return null

    // Helper to row styling
    const RowItem = ({ label, value }) => (
        <div className="d-flex justify-content-between align-items-center mb-3">
            <span style={{ color: "#999999", fontSize: "14px", fontWeight: "500" }}>
                {label}
            </span>
            <span style={{ color: "#FFCA5C", fontSize: "14px", fontWeight: "bold" }}>
                {value}
            </span>
        </div>
    )

    // formatting remittance logic
    const getRemittanceString = () => {
        let text = location.partner_remittance_terms || "-"
        if (location.partner_remittance_amount > 0) {
            text += ` ($${location.partner_remittance_amount})`
        } else if (location.partner_remittance_percent > 0) {
            text += ` (${location.partner_remittance_percent}%)`
        }
        return text
    }

    return (
        <Card
            style={{
                backgroundColor: "#383838", // Matching dark grey from image
                borderRadius: "15px",
                border: "none",
                height: "100%",
                boxShadow: "0 4px 6px rgba(0,0,0,0.2)"
            }}
        >
            <CardBody className="p-4">
                <h5 style={{ color: "#FFCA5C", fontWeight: "bold", marginBottom: "25px" }}>
                    Other Details
                </h5>

                <div className="mb-4">
                    <RowItem
                        label="Labor Hours Cap"
                        value={location.labor_hours_cap ? `${location.labor_hours_cap} Hours` : "-"}
                    />
                    <RowItem
                        label="Spaces (total)"
                        value={location.location_spaces || "0"}
                    />
                    <RowItem
                        label="Manager Labor Rate"
                        value={location.manager_labor_rate ? `$${location.manager_labor_rate}/hr` : "-"}
                    />
                    <RowItem
                        label="Attendant Labor Rate"
                        value={location.attendant_labor_rate ? `$${location.attendant_labor_rate}/hr` : "-"}
                    />
                    <RowItem
                        label="Partner Remittance Terms"
                        value={getRemittanceString()}
                    />
                    <RowItem
                        label="Invoice Directives"
                        value={location.invoice_directives || "-"}
                    />
                </div>

                {/* Accounting Notes Section */}
                <div>
                    <span style={{ color: "#999999", fontSize: "14px", fontWeight: "500", display: "block", marginBottom: "8px" }}>
                        Accounting Notes
                    </span>
                    <p style={{ color: "#FFCA5C", fontSize: "14px", lineHeight: "1.5" }}>
                        {location.finance_terms && location.finance_terms.length > 0
                            ? location.finance_terms.map(t => t.term).join(", ")
                            : "No notes available"}
                    </p>
                </div>
            </CardBody>
        </Card>
    )
}

LocationOtherDetailsCard.propTypes = {
    location: PropTypes.object
}

export default LocationOtherDetailsCard